"use client";

import { Suspense } from "react";
import {
	SortOptions,
	sortOptionSchema,
	useArticleFilters,
} from "~/components/bloks/ArticleListingPageBlok/useArticleFilter";
import { NativeSelect } from "~/components/ui/Select/select";
import styles from "./ArticleListingPageBlok.module.css";

interface Props {
	count?: number;
}

const UnsuspendedClientArticleFilter = ({ count = 0 }: Props) => {
	const { sort, setSort } = useArticleFilters();

	const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const value = sortOptionSchema.safeParse(e.target.value);
		if (value.success) {
			setSort(value.data);
		}
	};

	return (
		<fieldset className={styles.articleFilter}>
			<legend className="sr-only">Filtrer artikler</legend>
			<div />

			<div className={styles.count}>
				{count} {count > 1 ? "Artikler" : "Artikkel"}
			</div>
			<div className={styles.sort}>
				<NativeSelect
					onChange={handleSortChange}
					name="sort"
					title="Sorter artikler"
					value={sort}
					defaultValue={SortOptions.Newest}
				>
					<option value={SortOptions.Newest}>Nyeste</option>
					<option value={SortOptions.Oldest}>Eldste</option>
				</NativeSelect>
			</div>
		</fieldset>
	);
};

export const ClientArticleFilter: typeof UnsuspendedClientArticleFilter = (props) => {
	return (
		<Suspense>
			<UnsuspendedClientArticleFilter {...props} />
		</Suspense>
	);
};
